<template>
  <div>
    <van-dialog
      v-model="visible"
      :show-cancel-button="false"
      :show-confirm-button="false"
      class="dialog"
      :style="{
        background: `url(${backgroundImage}) no-repeat`
      }"
    >
      <div @click="removeClick" class="removeImage">
        <van-image :src="removeImage"> </van-image>
      </div>
      <div v-if="titleImage" class="title">
        <van-image :src="titleImage"> </van-image>
      </div>
      <div class="dialogWarp">
        <div class="textImageWarp">
          <van-image class="textImage1" :src="textImage1"> </van-image>
          <van-image class="textImage" @click="clickme" :src="textImage">
          </van-image>
        </div>
        <!-- <van-image :src="textImage"> </van-image> -->
      </div>
    </van-dialog>
  </div>
</template>

<script>
import getData from '../../../../../utils/request/request'
import { Toast } from 'vant'
import { mapGetters } from 'vuex'
import browser from '../../../../../utils/browser.js'
import getButton from '../../../../../utils/getButton'

export default {
  name: 'readmeDialog',
  props: {
    visible: Boolean,
    titleImage: String,
    backgroundImage: String,
    removeImage: String,
    textImage: String,
    textImage1: String,
    textListImage: String
  },
  computed: {
    ...mapGetters(['phone', 'gameStatus'])
  },
  data() {
    return {
      browser: browser(),
      timeFn: null
    }
  },
  methods: {
    removeClick(val) {
      this.$emit('changeVisible', val)
    },
    async share_slm() {
      let Api = {
        url: '/api/share_slm',
        type: 'post'
      }
      let form = {
        utm: this.$route.query.utm_source ? this.$route.query.utm_source : '',
        phone: this.phone
      }
      let res = await getData(this.$http(Api, form))
      if (res.code === 1) {
        this.$emit('getStatus')
        this.removeClick(false)
      } else {
        Toast(res.msg)
      }
    },
    async clickme() {
      getButton('FB分享')
      await this.share_slm()
      const url = encodeURIComponent(
        'https://www.lingluk.com/crossgate.tw/prereg'
      )
      const facebook = `https://www.facebook.com/sharer/sharer.php?u=${url}`
      if (this.browser.iPhone) {
        window.location.href = facebook
      } else if (this.browser.android) {
        window.open(facebook)
      } else {
        window.open(facebook)
      }
      // const _this = this
      // setTimeout(() => {
      //   FB.ui(
      //     {
      //       display: 'popup',
      //       method: 'share_open_graph',
      //       action_type: 'og.likes',
      //       action_properties: JSON.stringify({
      //         object: 'https://www.lingluk.com/crossgate.tw/prereg'
      //       })
      //     },
      //     function (response) {
      //       if (!response || response.error_message) {
      //         Toast('分享失败')
      //       } else {
      //         _this.share_slm()
      //       }
      //     }
      //   )
      // }, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog {
  background-size: 100% 100% !important;
  .title {
    padding: 2rem;
    padding-bottom: 0rem;
    /deep/ .van-image {
      width: 30%;
      display: block;
      margin: 0 auto;
    }
  }
}
.removeImage {
  position: absolute;
  width: 20px;
  top: 15px;
  right: 15px;
  z-index: 1000;
}
.dialogWarp {
  height: 350px;
  padding: 1rem 2.5rem;
  position: relative;
  .textImageWarp {
    width: 80%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    /deep/ .van-image:nth-child(1) {
      width: 80%;
      margin: 0 auto;
      display: block;
    }
    /deep/ .van-image:nth-child(2) {
      width: 70%;
      margin: 1rem auto;
      margin-top: 30px;
      display: block;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/route/src/prereg/components/shareDialog/index.vue